import { BEMBlock } from 'helpers/classnames';
import { ProductPrices } from 'palette/candidates';
import { ProductPricesCollection } from 'palette/candidates/ProductPrices/types';
import './PriceWrapper.scss';

interface PriceWrapperProps {
    bemModifier?: string;
    pricesStructure: ProductPricesCollection[];
}

function PriceWrapper({ bemModifier, pricesStructure }: PriceWrapperProps) {
    const [block] = BEMBlock('palette-product-card-price-wrapper', {
        [`${bemModifier}`]: bemModifier,
    });

    return (
        <div className={block}>
            <ProductPrices
                productPrices={pricesStructure}
            />
        </div>
    );
}

export default PriceWrapper;
